/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_ApparelInputs */

const en_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparel`)
};

const es_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ropa`)
};

const fr_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vêtements`)
};

const de_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekleidung`)
};

const ja_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アパレル`)
};

const zh_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服饰`)
};

const ar_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملابس`)
};

const id_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakaian`)
};

const it_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbigliamento`)
};

const ru_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одежда`)
};

const pt_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vestuário`)
};

const ko_listing_category_apparel = /** @type {(inputs: Listing_Category_ApparelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`의류`)
};

/**
* | output |
* | --- |
* | "Apparel" |
*
* @param {Listing_Category_ApparelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_apparel = /** @type {((inputs?: Listing_Category_ApparelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_ApparelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_apparel(inputs)
	if (locale === "es") return es_listing_category_apparel(inputs)
	if (locale === "fr") return fr_listing_category_apparel(inputs)
	if (locale === "de") return de_listing_category_apparel(inputs)
	if (locale === "ja") return ja_listing_category_apparel(inputs)
	if (locale === "zh") return zh_listing_category_apparel(inputs)
	if (locale === "ar") return ar_listing_category_apparel(inputs)
	if (locale === "id") return id_listing_category_apparel(inputs)
	if (locale === "it") return it_listing_category_apparel(inputs)
	if (locale === "ru") return ru_listing_category_apparel(inputs)
	if (locale === "pt") return pt_listing_category_apparel(inputs)
	return ko_listing_category_apparel(inputs)
});